import { FC, PropsWithChildren } from 'react'
import './AppFormRow.css'

export const AppFormRow: FC<
    PropsWithChildren<
        React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
        & {flex?:boolean}
>> = ({ children, flex, ...props }) => (
    <div className={`app-form-row ${ flex ? 'app-flex-row' : '' }`} { ...props } >{ children }</div>
);
